import React from 'react';
import PropTypes from 'prop-types';

const FormattedBreaks = props => props.text.split('\n').map((item, key) => <React.Fragment key={key}>{item}<br/></React.Fragment>);

FormattedBreaks.propTypes = {
    text: PropTypes.string.isRequired
};

export default FormattedBreaks;